import { get, post } from '../../common/httpService';

const getQAndA = (slug, pageSize = 5, page = 0, sortType = 2) => {
    return get({
        url: `QuestionAndAnswers/QuestionsAndAnswersJson?productSlug=${slug}&page=${page}&pageSize=${pageSize}&t=${sortType}`,
    });
};

const reportQuestionAbuse = (questionId, slug, type) => {
    return post({
        url: `QuestionAndAnswers/UserReportQuestionAbuse/${questionId}?ProductSlug=${slug}`,
        body: type,
    });
};

const userVoteYes = (questionId, answerId, slug) => {
    return post({
        url: `QuestionAndAnswers/UserVoteYes/${questionId}?AnswerId=${answerId}`,
        body: slug,
    });
};

const userVoteNo = (questionId, answerId, slug) => {
    return post({
        url: `QuestionAndAnswers/UserVoteNo/${questionId}?AnswerId=${answerId}`,
        body: slug,
    });
};

const reportAnswerAbuse = (questionId, answerId, slug, type) => {
    return post({
        url: `QuestionAndAnswers/UserReportAnswerAbuse/${questionId}?AnswerId=${answerId}&ProductSlug=${slug}`,
        body: type,
    });
};

export {
    getQAndA,
    reportQuestionAbuse,
    userVoteYes,
    userVoteNo,
    reportAnswerAbuse,
};
